import { all, call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import {
  GeneralUtilsAction,
  InitAction,
  PettyCashierReceiveAction,
  UploadImageAction
} from "../../actions";
import * as receiveApi from "../../api/receive/pettyCashierReceive";
import { toastr } from "react-redux-toastr";
import { goBack, push, replace } from "connected-react-router";
import { createBrowserHistory } from "history";
import {
  PETTY_CASH_PETTY_CASHIER,
  SUMMARY_RECEIVE_PETTY_CASHIER
} from "../../constants/urls";
import imageCompression from "browser-image-compression";
import { SetMessage } from "../../assets/errorMessages";

export function* pettyCashierWatcherReceive() {
  yield takeLatest(types.PETTY_CASHIER_REMOVE_RECEIVE_REQUEST, remove);
  yield takeLatest(types.PETTY_CASHIER_GET_IMAGE_RECEIVE_REQUEST, getImage);
  yield takeLatest(types.PETTY_CASHIER_STORE_RECEIVE_REQUEST, store);
  yield takeLatest(types.PETTY_CASHIER_GET_RECEIVE_REQUEST, get);
  yield takeLatest(types.PETTY_CASHIER_UPDATE_RECEIVE_REQUEST, update);
}

async function storeReq(data) {
  return receiveApi.store(data);
}

function* store(action) {
  const history = createBrowserHistory();
  try {
    yield put(UploadImageAction.showModal(action.files));
    yield put(GeneralUtilsAction.dateAndTimeMaintain());
    const response = yield call(storeReq, action.data);
    yield put(UploadImageAction.uploadImageRequest(action.files));
    yield all(
      action.files.map((file, i) =>
        storeImageReq(response.data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());

    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });

    yield put(PettyCashierReceiveAction.storeSuccess());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));

    if (
      !action.reload &&
      history.location.state &&
      history.location.state.from === PETTY_CASH_PETTY_CASHIER
    ) {
      yield put(goBack());
    } else if (action.reload) {
      yield put(GeneralUtilsAction.dateAndTimeMaintain(action.reload));
    } else {
      yield put(
        replace({
          pathname: `${SUMMARY_RECEIVE_PETTY_CASHIER}/${response.data.data.id}`
        })
      );
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierReceiveAction.storeFailure());
    yield put(UploadImageAction.hideModal());
  }
}

async function getImageReq(id) {
  return receiveApi.getImage(id);
}

function* getImage(action) {
  try {
    const response = yield call(getImageReq, action.id);
    yield put(PettyCashierReceiveAction.getImageSuccess(response.data.data));
  } catch (error) {
    SetMessage(error);
    yield put(PettyCashierReceiveAction.getImageFailure(error));
  }
}

async function updateReq(id, data) {
  return receiveApi.update(id, data);
}
function* update(action) {
  try {
    yield put(UploadImageAction.showModal(action.files));
    const response = yield call(updateReq, action.id, action.data);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(UploadImageAction.uploadImageRequest(action.files));

    yield all(
      action.files.map((file, i) =>
        storeImageReq(response.data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());

    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });

    yield put(PettyCashierReceiveAction.updateSuccess());
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierReceiveAction.updateFailure());
    yield put(UploadImageAction.hideModal());
  }
}

function* storeImageReq(id, file, index) {
  if (!file.id) {
    const options = {
      maxSizeMB: 0.7,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    try {
      const compressedResult = yield call(imageCompression, file, options);
      const responseImg = yield call(
        receiveApi.storeImage,
        compressedResult,
        id
      );
      if (responseImg.data && responseImg.data.premium) {
        yield put(
          InitAction.getSuccess({ updatePremium: responseImg.data.premium })
        );
      }
      yield put(UploadImageAction.uploadImageSuccess(index));
      return responseImg;
    } catch (error) {
      toastr.error("", `ارسال عکس ${index + 1} با خطا رو‌به‌رو شد.`);
      yield put(UploadImageAction.uploadImageFailure(index));
      return error;
    }
  }
}

function* get(action) {
  try {
    const response = yield call(getRequest, action.id);
    yield put(PettyCashierReceiveAction.getSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierReceiveAction.getFailure(message));
  }
}
function getRequest(id) {
  return receiveApi.get(id);
}

async function removeReq(id) {
  return receiveApi.remove(id);
}

function* remove(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(removeReq, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(
      PettyCashierReceiveAction.removeSuccess(response.data, action.id)
    );
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    if (action.goBack) {
      if (history.location.state && history.location.state.from) {
        yield put(push(history.location.state.from));
      } else {
        yield put(goBack());
      }
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierReceiveAction.removeFailure(error, action.id));
  }
}
